<template>
    <div class="jf_container">
        <div class="jf_conditionBox kaohe">
            <mySearch
                class="my-search"
                @searchData="searchData"
                :paramData="searchParam"
                searchApi="point_staff_center/index"
                v-model="searchContent"
            ></mySearch>
            <el-date-picker
                class="picker"
                v-model="date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="searchParam.date=date;getAllIntegral()"
            ></el-date-picker>
            <el-select
                class="topSelect"
                v-model="searchParam.typeid"
                placeholder="请选择分类"
                clearable
                @change="getAllIntegral()"
            >
                <el-option
                    v-for="item in assortArray"
                    :key="item.id+1000"
                    :label="item.typename"
                    :value="item.id"
                >
                    <span :class="{'secondary': item.pid!==0}">{{item.typename}}</span>
                </el-option>
            </el-select>
        </div>
        <div class="jf-grjl_mian clearfix">
            <!-- 左侧记录 -->
            <div class="jf-grjl_left">
                <img
                    class="avatar"
                    :src="myIntegral.img"
                    alt
                    v-if="myIntegral && myIntegral.img!=''"
                />
                <img class="avatar" src="/static/qmsj/img/jifen/default_head_img.png" alt v-else />

                <ul class="paiming" v-if="myIntegral">
                    <li style="margin-right:60px">
                        <p>{{myIntegral.month_rank}}</p>
                        <p>本月排名</p>
                    </li>
                    <li>
                        <p>{{myIntegral.year_rank}}</p>
                        <p>年度排名</p>
                    </li>
                    <li style="margin-left:60px">
                        <p>{{myIntegral.all_rank}}</p>
                        <p>累计排名</p>
                    </li>
                </ul>
                <p class="jifenNum">
                    <span class="numTitle">当前总积分</span>
                    <span class="num">
                        <b>{{myIntegral.point_all}}</b>分
                    </span>
                </p>
                <p class="jifenNum">
                    <span class="numTitle">本月奖励</span>
                    <span class="num">
                        <b>{{myIntegral.scoreinc}}</b>分
                    </span>
                </p>
                <p class="jifenNum">
                    <span class="numTitle">本月扣分</span>
                    <span class="num">
                        <b>{{myIntegral.scoredec}}</b>分
                    </span>
                </p>
                <p class="jifenNum">
                    <span class="numTitle">可兑换积分</span>
                    <span class="num">
                        <b>{{myIntegral.point_last}}</b>分
                    </span>
                </p>
                <div class="btnWrap">
                    <button class="jiluBtn" @click="showPopup=1">兑换记录</button>
                    <button class="duihuanBtn" @click="handleShowPopup">兑换</button>
                </div>
            </div>
            <!-- 右侧表格 -->
            <div class="jf-grjl_right">
                <!-- 数据表格 -->
                <el-table class="elTable" :data="integralTable" height="75%">
                    <el-table-column
                        prop="typename"
                        label="积分分类"
                        align="center"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        prop="rule_name"
                        label="规则名称"
                        align="center"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        prop="rule_des"
                        label="积分细则"
                        align="center"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column label="奖惩分数" align="center">
                        <template slot-scope="scope">
                            <span :style="{'color':scope.row.rule_type==1?'#67C23A':'#F56C6C'}">{{scope.row.rule_type==1?'+':'-'}}{{scope.row.score}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="标准分数" align="center">
                        <template slot-scope="scope">
                            <span>
                                {{scope.row.score_type == 1 ? scope.row.score_fixed: scope.row.score_min+' ~ '+scope.row.score_max}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="check_time" label="申请日期" align="center"></el-table-column>
                </el-table>
                <!-- 页码 -->
                <p
                    class="pageTotal"
                >共有 {{pageData.count}} 条记录 当前 {{pageData.page}} 页/共 {{pageData.pagetotal}} 页</p>
                <el-pagination
                    class="pageBody"
                    @current-change="getAllIntegral(1)"
                    :current-page.sync="pageData.page"
                    background
                    layout="prev, pager, next"
                    :total="pageData.count*1"
                ></el-pagination>
            </div>
        </div>
        <!-- 兑换、记录弹窗 -->
        <div class="myDialog duihuan_dialog" v-if="showPopup">
            <div class="myDialog_content shenqing-myDialog_content" :style="{'width': showPopup===1?'700px':'500px'}">
                <h4 class="myDialog_h">
                    {{showPopup === 1?'兑换记录':'请选择兑换礼品'}}
                    <i
                        class="close el-icon-circle-close-outline"
                        @click="showPopup=0"
                    ></i>
                </h4>
                <div v-if="showPopup===2">
                    <p class="canExchange">可兑换积分：<span>{{myIntegral.point_last}}</span></p>
                    <h5 class="duihuanTitle">现金</h5>
                    <div class="inp_wrap">
                        <label>金额:</label>
                        <el-input type="number" v-model="exchangeMoney"
                        :style="{'width':myIntegral.exchange == 'no'?'170px!important':'150px!important'}"
                        :placeholder="myIntegral.exchange == 'no'?myIntegral.point_last==0?'积分不足':myIntegral.point_exchange_time+'后可兑换':''"
                        :disabled="myIntegral.exchange == 'no'?true:false"></el-input>&nbsp;
                    </div>
                    <h5 class="duihuanTitle">礼品</h5>
                    <div class="inp_wrap">
                        <label>商品名称:</label>
                        <button class="showGoodsBtn" @click="dialogzeng=true">请选择商品</button>
                    </div>
                    <ul class="giftImg" v-if="giftData.length>0">
                        <li v-for="(img, index) in giftData" :key="index+600">
                            <i class="el-icon-error" @click="deleteGoods(index)"></i>
                            <img :src="img" alt="gift" />
                        </li>
                    </ul>
                    <div class="btnWrap">
                        <button class="assort_confim-btn" @click="showPopup=0">取消</button>
                        <button class="assort_confim-btn confim" @click="submitExchange">确定</button>
                    </div>
                </div>
                <div v-else>
                    <el-date-picker
                        class="picker"
                        v-model="exchangeTIme"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                        @change="getExchangeRecord()"
                    ></el-date-picker>
                    <el-table class="duihuanTable" :data="exchangeTable" height="400">
                        <el-table-column prop="point" label="兑换积分" align="center"></el-table-column>
                        <el-table-column
                            prop="gift"
                            label="礼品"
                            align="center"
                            :show-overflow-tooltip="true"
                        ></el-table-column>
                        <el-table-column
                            prop="create_time"
                            label="时间"
                            align="center"
                            :show-overflow-tooltip="true"
                        ></el-table-column>
                        <el-table-column prop="username" label="操作人" align="center"></el-table-column>
                    </el-table>
                    <!-- 页码 -->
                    <p
                        class="pageTotal"
                    >共有 {{exchangePage.count}} 条记录 当前 {{exchangePage.page}} 页/共 {{exchangePage.pagetotal}} 页</p>
                    <el-pagination
                        class="pageBody"
                        @current-change="getExchangeRecord()"
                        background
                        layout="prev, pager, next"
                        :total="exchangePage.count*1"
                    ></el-pagination>
                </div>
            </div>
        </div>
        <!-- 添加赠品图片弹框 -->
        <el-dialog
            id="newlist"
            class="mynewlist"
            title="title"
            :visible.sync="dialogzeng"
            width="80%"
            center
        >
            <span slot="title" class="dialog-title">
                <div class="demo-input-suffix all">
                    <el-row>
                        <el-col :span="12">
                            <div class="grid">
                                全部分类:
                                <el-select
                                    class="all_kind"
                                    size="small"
                                    style="width: 160px;"
                                    v-model="search.kind"
                                    clearable
                                    placeholder="全部分类"
                                    @change="loaddata"
                                >
                                    <el-option
                                        v-for="item in good_types"
                                        :key="item.id"
                                        :label="item.type_name"
                                        :value="item.id"
                                    ></el-option>
                                </el-select>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div
                                class="grid gridnimei"
                                style="width: 180px;"
                                @keyup.enter="searchname"
                            >
                                <el-input
                                    class="all_kind"
                                    size="small"
                                    placeholder="请输入商品名称"
                                    v-model="search.name"
                                >
                                    <div slot="append" class="el-icon-search" @click="searchname"></div>
                                </el-input>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </span>
            <span>
                <el-table
                    ref="multipleTable"
                    :data="tableData.data"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
                    height="440px"
                    border
                >
                    <el-table-column type="selection" width="30"></el-table-column>
                    <el-table-column prop="good_num" label="商品编号" width="150" align="center"></el-table-column>
                    <el-table-column prop="good_name" label="商品名称" align="center"></el-table-column>
                    <el-table-column label="图片" align="center">
                        <template slot-scope="scope">
                            <span>
                                <img
                                    :src="scope.row.mini_imgpath"
                                    style="height: 30px;width: 30px;"
                                />
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="spec" label="规格" align="center"></el-table-column>
                    <el-table-column prop="unit" label="单位" align="center"></el-table-column>
                    <el-table-column prop="exchange_integral" label="兑换积分" align="center"></el-table-column>
                    <el-table-column prop="stock" label="可用库存" align="center"></el-table-column>
                    <el-table-column prop="limit" width="120" label="限量" align="center">
                        <template slot-scope="scope" style="line-height:20px">
                            <el-input-number
                                size="mini"
                                v-model="scope.row.limit"
                                :min="0"
                                :max="scope.row.stock"
                                label="描述文字"
                            ></el-input-number>
                        </template>
                    </el-table-column>
                </el-table>

                <p class="pager">
                    <span>共{{tableData.total}}条记录</span>
                    当前{{tableData.page}}页/共{{tableData.totalpage}}页
                </p>
                <el-pagination
                    class="f_page"
                    background
                    @current-change="handleCurrentChange"
                    :current-page="tableData.page"
                    layout="prev, pager, next"
                    :total="tableData.total"
                ></el-pagination>
            </span>
            <span slot="footer" class="dialog-footer">
                <el-row>
                    <el-col :span="12">
                        <div style="padding-left: 200px">
                            <el-button @click="dialogzeng = false">取 消</el-button>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div style="padding-right: 200px">
                            <el-button type="warning" @click="getgift">确 定</el-button>
                        </div>
                    </el-col>
                </el-row>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import mySearch from "../../components/mySearch.vue";
var baseUrl = process.env.apiUrl + "point/";
export default {
    name: "gerenjilu",
    data() {
        return {
            integralTable: [],
            token: "",
            showPopup: 0, // 显示弹窗  1-兑换记录   2-兑换
            date: "",
            searchParam: {
                from: 1,
                date: "",
                shenhe: 1,
                typeid: ""
            },
            searchContent: "",
            assortArray: [],
            pageData: {
                count: "", // 总条数
                page: 1, // 当前页
                pagetotal: "" // 总页数
            }, // 页数
            myIntegral: "", // 左侧个人积分
            exchangeTable: [],
            exchangeTIme: "",
            exchangePage: {
                count: "", // 总条数
                page: 1, // 当前页
                pagetotal: "" // 总页数
            },
            //  商品弹窗内变了
            dialogzeng: false,
            search: {
                kind: "",
                name: ""
            },
            tableData: {
                data: [],
                page: 1,
                total: 0,
                totalpage: 10
            },
            good_types: [],
            multipleSelection: [],
            selectedGift: [],
            giftData: [],
            exchangeMoney: "",
        };
    },
    created() {
        this.token = this.$cookies.get("token");
        this.getMyIntegral();
        this.getAllIntegral();
        this.getAssortList();
        this.loaddata();
        this.getGoodsType();
        this.getExchangeRecord();
    },
    methods: {
        // 获取分类列表
        async getAssortList() {
            let that = this;
            try {
                let res = await that.$http.post(baseUrl + "point_type/index", {
                    token: that.token
                });
                if (res.status == 1) {
                    if (res.data && res.data.length > 0) {
                        that.assortArray = [];
                        res.data.forEach((element, index) => {
                            that.assortArray.push({
                                typename: element.typename,
                                pid: element.pid,
                                id: element.id
                            });
                            if (element.child && element.child.length > 0) {
                                element.child.forEach((ele, i) => {
                                    that.assortArray.push({
                                        typename: ele.typename,
                                        pid: ele.pid,
                                        id: ele.id
                                    });
                                });
                            }
                        });
                    }
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        },
        // 获取全部积分列表
        async getAllIntegral(type) {
            if (type !== 1) {
                this.pageData.page = 1
            }
            let that = this;
            try {
                let res = await that.$http.post(
                    baseUrl + "point_staff_center/index",
                    {
                        token: that.token,
                        time_s:
                            that.date && that.date.length > 0
                                ? that.date[0]
                                : "",
                        time_e:
                            that.date && that.date.length > 0
                                ? that.date[1]
                                : "",
                        search: that.searchContent,
                        page: that.pageData.page,
                        typeid: that.searchParam.typeid
                    }
                );
                if (res.status == 1) {
                    that.integralTable = res.data;
                    that.pageData.count = res.map.count;
                    that.pageData.page = res.map.page*1;
                    that.pageData.pagetotal = res.map.pagetotal;
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        },
        // 获取个人积分信息
        async getMyIntegral() {
            let that = this;
            try {
                let res = await that.$http.post(
                    baseUrl + "point_staff_center/score_ranking",
                    {
                        token: that.token
                    }
                );
                if (res.status == 1) {
                    that.myIntegral = res.data;
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        },
        // 获取个人积分记录列表 兑换记录
        async getExchangeRecord() {
            let that = this;
            try {
                let res = await that.$http.post(
                    baseUrl + "point_staff_center/exchange_record",
                    {
                        token: that.token,
                        time_s:
                            that.exchangeTIme && that.exchangeTIme.length > 0
                                ? that.exchangeTIme[0]
                                : "",
                        time_e:
                            that.exchangeTIme && that.exchangeTIme.length > 0
                                ? that.exchangeTIme[1]
                                : "",
                        page: that.exchangePage.page
                    }
                );
                if (res.status == 1) {
                    that.exchangeTable = res.data;
                    that.exchangePage.count = res.map.count;
                    that.exchangePage.page = res.map.page;
                    that.exchangePage.pagetotal = res.map.pagetotal;
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        },
        searchData(data) {
            this.integralTable = data.data;
            this.pageData.count = data.map.count;
            this.pageData.page = data.map.page*1;
            this.pageData.pagetotal = data.map.pagetotal;
        },
        handleShowPopup() {
            // if (this.myIntegral.exchange == "no") {
            //     this.$message.warning("您已兑换完成,请"+this.myIntegral.point_exchange_time+"下次再来兑换");
            //     return;
            //     this.show_exchangemoney = false;
            // }
            this.showPopup = 2;
        },
        // 商品弹窗函数
        // 搜索商品名称
        searchname() {
            this.tableData.page = 1;
            this.loaddata();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 添加赠品图片
        getgift() {
            let selectedImg = [];
            this.selectedGift = [];
            for (
                let index = 0;
                index < this.multipleSelection.length;
                index++
            ) {
                const element = this.multipleSelection[index];
                selectedImg.push(element.mini_imgpath);
                this.selectedGift.push({
                    id: element.id,
                    num: element.limit
                });
                //判断赠品限量是否填写 不能为0
                if (element.limit == 0) {
                    this.$message.warning("商品限量不能为零");
                    selectedImg = [];
                    this.selectedGift = {};
                    return false;
                }
            }
            this.dialogzeng = false;
            this.giftData = selectedImg;
        },
        // 赠品接口
        loaddata() {
            var arr = this;
            $.ajax({
                url: baseUrl + "point_staff_center/goods_list",
                type: "post",
                data: {
                    token: arr.token,
                    search: arr.search.name,
                    typeid: arr.search.kind,
                    page: arr.tableData.page
                },
                success: function(response) {
                    if (response.map.count == 0) {
                        arr.tableData.data = [];
                        arr.tableData.total = 0;
                        arr.tableData.totalpage = 1;
                    } else {
                        arr.tableData.data = response.data;
                        arr.tableData.total = response.map.count;
                        arr.tableData.totalpage = response.map.pagetotal;
                    }
                }
            });
        },
        handleCurrentChange(val) {
            this.tableData.page = val;
            this.loaddata();
        },
        async getGoodsType() {
            let that = this;
            try {
                let res = await that.$http.post(
                    baseUrl + "point_staff_center/goods_type",
                    { token: that.token }
                );
                if (res.status == 1) {
                    that.good_types = res.data;
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        },
        deleteGoods(i) {
            this.giftData.splice(i, 1);
            this.selectedGift.splice(i, 1);
        },
        // 兑换提交
        async submitExchange() {
            if (this.exchangeMoney == "" && this.selectedGift.length === 0) {
                this.$message.warning("请兑换现金红包或者礼品");
                return;
            }
            let that = this;
            try {
                let res = await that.$http.post(
                    baseUrl + "point_staff_center/exchange_goods",
                    {
                        token: that.token,
                        score: that.exchangeMoney,
                        goods_id: that.selectedGift,
                        type: 2
                    }
                );
                if (res.status == 1) {
                    that.$message.success("兑换成功");
                    that.getMyIntegral();
                    that.getExchangeRecord();
                    that.exchangeMoney = "";
                    that.selectedGift = [];
                    that.giftData = [];
                    that.showPopup = 0;
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        }
    },
    components: {
        mySearch
    }
};
</script>
<style scoped>
.jf_conditionBox {
    width: 100%;
    min-width: 1100px;
    height: 60px;
    padding-top: 10px;
    padding-left: 416px;
    background: #f5f5f5;
}
.picker,
.my-search,
.topSelect {
    float: left;
    margin-right: 10px;
}
.jf-grjl_mian {
    width: 100%;
    min-width: 1100px;
    height: calc(100vh - 212px);
    padding-left: 30px;
    background: #f5f5f5;
}
.jf-grjl_left {
    float: left;
    margin-top: -50px;
    width: 370px;
    height: calc(100vh - 168px);
    overflow-y: scroll;
    background: #fff;
}
.jf-grjl_right {
    float: left;
    margin-left: 16px;
    width: calc(100% - 420px);
    min-width: 600px;
    max-width: 1000px;
    height: calc(100vh - 218px);
    padding-top: 20px;
    background: #fff;
}
.jf-grjl_right .elTable {
    margin: 0 auto;
    width: 95%;
    min-width: unset;
}
.avatar {
    display: block;
    width: 88px;
    height: 88px;
    border-radius: 50%;
    margin: 38px auto 30px;
}
li {
    list-style: none;
}
.paiming {
    text-align: center;
    margin-bottom: 20px;
}
.paiming li {
    display: inline-block;
    width: 60px;
    height: 60px;
}
.paiming p {
    font-size: 14px;
    line-height: 30px;
    color: #999;
}
.paiming p:first-child {
    font-size: 20px;
    font-weight: 600;
    color: #333;
}
.jifenNum {
    height: 54px;
    padding: 0 33px;
    color: #999;
}
.numTitle {
    float: left;
    font-size: 14px;
    line-height: 36px;
}
.num {
    float: right;
    font-size: 14px;
    color: #333;
}
.num b {
    font-size: 20px;
}
.btnWrap {
    margin-top: 20px;
    text-align: center;
}
.jiluBtn,
.duihuanBtn {
    margin: 0 16px;
    width: 100px;
    height: 30px;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 600;
    color: #E6BE8A;
    background: #f1f1f1;
    outline: none;
}
.duihuanBtn {
    color: #fff;
    background: #E6BE8A;
}
.myDialog_content {
    width: 500px;
}
.close {
    float: right;
    margin: 8px 20px;
}
.duihuanTitle {
    margin: 30px 0 -10px 0;
    padding-left: 30px;
    font-size: 16px;
    font-weight: 700;
    color: #333;
}
.inp_wrap label {
    width: 70px;
}
.btnWrap {
    text-align: center;
}
.btnWrap .assort_confim-btn {
    display: inline-block;
    margin: 30px 20px 0;
}
.confim {
    color: #fff;
    background: #E6BE8A;
}
.duihuanTable {
    margin: 20px;
    width: 90%;
}
.duihuan_dialog .picker {
    margin: 20px;
}
/* ****************************************************************************************** */
#newlist .dialog-title {
    background-color: #E6BE8A;
    width: 100%;
    height: 50px;
    display: inline-block;
    padding-top: 10px;
}
#newlist .el-dialog__header {
    padding: 0;
}
#newlist .all {
    color: white;
}
#newlist .el-table thead {
    color: #7c7f85;
}
#newlist .el-table td,
#newlist .el-table th {
    padding: 0;
}
#newlist .el-checkbox__input.is-checked .el-checkbox__inner,
#newlist .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #E6BE8A;
    border-color: #E6BE8A;
}
#newlist .el-checkbox__inner:hover {
    border-color: #E6BE8A;
}
#newlist .el-input-number--mini .el-input-number__decrease,
#newlist .el-input-number--mini .el-input-number__increase {
    background: #fff;
    color: #E6BE8A;
    border: 1px solid #E6BE8A;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    line-height: 16px;
    top: 8px;
    /* margin-left: 10px;
        margin-right: 10px; */
}
#newlist .el-checkbox__original {
    display: none;
}
#newlist .el-input-number--mini {
    width: 100px;
    line-height: 26px;
}
#newlist .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #E6BE8A;
    color: #fff;
}
#newlist .el-pagination.is-background .btn-next,
#newlist .el-pagination.is-background .btn-prev,
#newlist .el-pagination.is-background .el-pager li {
    margin: 0;
}
#newlist .el-button--primary {
    color: #fff;
    background-color: #E6BE8A;
    border-color: #E6BE8A;
}
#newlist .el-button--primary:focus,
#newlist .el-button--primary:hover {
    background: #E6BE8A;
    border-color: #E6BE8A;
    color: #fff;
}
#newlist .el-button {
    padding: 8px 15px;
}
#newlist .el-table__body {
    color: rgb(153, 153, 153);
}
.pager {
    color: rgb(153, 153, 153);
}
.pager span {
    margin-right: 5px;
}
.f_page {
    text-align: center;
}
#newlist .el-date-editor .el-range-input::placeholder {
    color: rgb(153, 153, 153);
}
#newlist .el-input__inner::placeholder {
    color: rgb(153, 153, 153);
}
#newlist .el-radio__input.is-checked .el-radio__inner {
    /* border-color: red; */
    background: #E6BE8A;
    border: 0;
}
#newlist .el-radio__input.is-checked + .el-radio__label {
    color: rgb(153, 153, 153);
}
#newlist .el-radio {
    color: rgb(153, 153, 153);
    margin-left: 5px;
}
#newlist .el-radio__inner:hover {
    border-color: rgb(153, 153, 153);
}
#newlist .el-radio__label {
    padding-left: 5px;
}
#newlist .el-radio + .el-radio {
    margin-left: 15px;
}
#newlist .el-input-group__append {
    background: white;
    border-radius: 0 20px 20px 0;
    padding: 0 10px 0;
}
/*#newlist .el-input__inner{*/
/*padding: 0 0 0 10px;*/
/*}*/
.my_span {
    width: 15px;
    height: 15px;
    border-radius: 50%;
    border: 1px solid rgb(153, 153, 153);
}
#newlist .el-table .cell {
    line-height: 15px;
}
#newlist .el-table th,
.el-table tr {
    line-height: 25px;
}
#newlist .el-dialog--center .el-dialog__body {
    text-align: center;
}
#newlist .el-dialog--center .el-dialog__body {
    padding: 0;
}
.showGoodsBtn {
    outline: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    width: 200px;
    height: 40px;
    font-size: 14px;
    background: none;
}
.giftImg {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
    width: 100%;
    padding: 0 30px;
}
.giftImg li {
    position: relative;
    margin: 8px 16px 8px 0;
}
.giftImg li i {
    position: absolute;
    top: -8px;
    right: -8px;
    width: 16px;
    height: 16px;
    font-size: 16px;
    cursor: pointer;
}
.giftImg li img {
    display: block;
    width: 60px;
    height: 50px;
}
.canExchange {
    position: absolute;
    top: 50;
    right: 14px;
    font-size: 14px;
}
.canExchange span {
    font-weight: 600;
    font-size: 16px;
}
.secondary {
    margin-left: 30px;
}
</style>




// WEBPACK FOOTER //
// src/pages/jifen/gerenjilu.vue